import { Sections } from '../types';
import { withPayloadType } from 'utils';
import { createAction } from '@reduxjs/toolkit';

export const createSectionStart = createAction(
  'CREATE_SECTION::START',
  withPayloadType<Sections>(),
);
